import { render, staticRenderFns } from "./TopNovelCard.vue?vue&type=template&id=fe8d2a72&scoped=true&"
import script from "./TopNovelCard.vue?vue&type=script&lang=js&"
export * from "./TopNovelCard.vue?vue&type=script&lang=js&"
import style0 from "./TopNovelCard.vue?vue&type=style&index=0&id=fe8d2a72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8d2a72",
  null
  
)

export default component.exports